import React from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import Select from 'react-select';
import { useDebouncedCallback } from 'use-debounce';

const DropDownFilterSearch = ({options, defaultText, value, onchange, paramkey, search}) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const pathname = location.pathname;
  const language = localStorage.getItem("i18nextLng");

  const handleSearch = (term) => {
    const params = new URLSearchParams(searchParams);
    if (term) {
      params.set(`${paramkey}`, term);
    } else {
      params.delete(`${paramkey}`);
    }
    navigate(`${pathname}?${params.toString()}`);
  };

  const handleChange = (selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : null;

    if (onchange) {
      onchange(selectedValue);
    }
    handleSearch(selectedValue);
  };

  const handleInputChange = useDebouncedCallback((inputValue) => {
    search(inputValue);
  }, 1000);

  const formattedOptions = (options || []).map((e) => ({
    value: String(e.id),
    label: language == "en" ? (e.name.en || e?.full_name) : (e.name.ar || e?.full_name) ,
  }));

  // Ensure the selected option is a reference to one of the formatted options
  const selectedValue = value != null ? String(value) : null;
  const selectedOption = formattedOptions.find((opt) => opt.value === selectedValue) ?? null;

  return (
    <Select
        name={paramkey}
        options={formattedOptions}
        placeholder={defaultText}
        onInputChange={handleInputChange}
        onChange={handleChange}
        className="w-full border border-gray-500/100 rounded-md "
        required
        value={selectedOption}
        isSearchable={true}
        styles={{
          control: (provided) => ({
            ...provided,
            backgroundColor: "#212529 ",
            color: "white",
            height: 40,
            minHeight: 40,
            border: "none",
          }),
          placeholder: (provided) => ({
            ...provided,
            color: "white",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",   // cut text with ...
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "white",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",   // cut selected text too
          }),
          input: (provided) => ({
            ...provided,
            color: "white",
          }),
          menu: (provided) => ({
            ...provided,
          }),
        }}
    />
  );
};

export default DropDownFilterSearch;